// extracted by mini-css-extract-plugin
module.exports = {"negative":"Typography__negative__3aG6o","meta":"Typography__meta__14tNy"};